export interface UpdateRoleMenuItem {
  menuItemId: string;
  readOnly: boolean;
}
